/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

const dematCharges = [
  ["Account Opening Fees", "<span>₹0</span>"],
  [
    "Annual Maintenance Charges*",
    "<span>For Non – BSDA Account  <br/><small>First Year AMC - ₹ 0, <br/> Next Year Onwards - ₹ 300 + GST </small> <br/> *For BSDA Account <br/> <small>(Refer Below)</small></span>"
  ],
  [
    "DP Transaction Charges",
    "<span>₹13.50 / transaction / ISIN + GST.<br/> <small>*(On Market)</span>"
  ],
  [
    "Margin Pledge Charges",
    "<span>₹15 / instruction / ISIN + GST.</span><br /><small>Involves all requests including pledge, unpledge and invocation.</small>"
  ]
];

export default dematCharges;
